import { ResultsLegFragment } from '@websky/graphql';

export const getSeatsLeftCount = (flight: ResultsLegFragment) => {
	return flight?.segments?.reduce((minValue: number | null, segment) => {
		const seatsLeft = segment.segment.lowestPriceClassSeatsLeft;

		if (!Number.isInteger(seatsLeft)) {
			return minValue;
		}

		if (minValue === null) {
			return seatsLeft;
		} else {
			return seatsLeft < minValue ? seatsLeft : minValue;
		}
	}, null);
};
